import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getListQuestion } from "../../../redux/actions/admin/questionActions";
import Pagination from "rc-pagination";
import Select from "@material-ui/core/Select";
import { useTranslation } from "react-i18next";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { getSkills } from "../../../redux/actions/admin/skillActions";

export default function ListQuestion(props) {
  const dispatch = useDispatch();
  const list = useSelector((state) => state.questionReducers);
  const [filterRecords, setFilterRecords] = useState(undefined);
  const [selectedSkill, setSelectedSkill] = useState(undefined);
  const { t, i18n } = useTranslation("common");
  const [data, setData] = useState({
    current: 1,
    init: 0,
    final: 4,
  });
  const [limit, setLimit] = useState({ init: 5 });
  const skill = useSelector((state) => state.skillsReducers);

  const handlePage = useCallback(
    (page) => {
      setData({
        current: page,
        final: page * limit.init - 1,
        init: page * limit.init - limit.init,
      });
    },
    [limit.init]
  );

  const onChangeFilterSkill = (event, value) => {
    if (value) {
      dispatch(getListQuestion(i18n.language, value.uuid));
      setSelectedSkill({ ...value });
    } else {
      dispatch(getListQuestion(i18n.language));
      setSelectedSkill(undefined);
    }
  };

  useEffect(() => {
    dispatch(getListQuestion(i18n.language));
  }, [dispatch, i18n.language]);

  useEffect(() => {
    if (limit.init > 0) {
      handlePage(1);
    }
  }, [dispatch, limit, handlePage]);

  useEffect(() => {
    const filter = list.questions_list.filter(
      (item, key) => key >= data.init && key <= data.final
    );
    setFilterRecords(filter);
  }, [dispatch, list, data]);

  useEffect(() => {
    if (!skill.loaded) dispatch(getSkills());
  }, [dispatch, skill.loaded]);

  return (
    <div className="my-10">
      <div className="w-10/12 mx-auto flex justify-between items-center mb-5">
        <Autocomplete
          id="list-question-skill"
          options={skill.records}
          getOptionLabel={(option) => option.name}
          style={{ width: 300 }}
          onChange={onChangeFilterSkill}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("skills.select")}
              variant="outlined"
            />
          )}
        />
        <Link
          to={`/tests/admin/list/question/skill/${selectedSkill?.uuid}`}
          className={`${
            !selectedSkill ? "pointer-events-none opacity-50" : ""
          }`}
          target="_blank"
        >
          <button className="bg-gray-100 inline-flex py-3 px-5 rounded-lg items-center hover:bg-gray-300 focus:outline-none">
            <i className="fas fa-print"></i>
            <span className="ml-4 flex items-start flex-col leading-none">
              <span className="text-xs text-gray-600 mb-1">
                {t("userSkills.print")}
              </span>
              <span className="title-font font-medium">
                {t("question.list_question")}
              </span>
            </span>
          </button>
        </Link>
      </div>
      <table className="w-10/12 mx-auto my-3">
        <thead>
          <tr>
            <th className="border border-gray-400 bg-gray-100 p-2">
              {t("skills.skill")}
            </th>
            <th className="border border-gray-400 bg-gray-100 p-2">
              {t("question.question")}
            </th>
            <th className="border border-gray-400 bg-gray-100 p-2">
              {t("question.answer")}
            </th>
          </tr>
        </thead>
        <tbody>
          {filterRecords !== undefined &&
            filterRecords.length > 0 &&
            Object.entries(filterRecords).map(([key, item]) => (
              <tr key={key}>
                <td className="border p-2 ">
                  {item.question_skills && item.question_skills.length > 0 && (
                    <>
                      {!selectedSkill ? (
                        Object.entries(item.question_skills).map(
                          ([key2, item2]) => (
                            <div key={key2}>
                              {item2.skill.name}
                              <br />
                            </div>
                          )
                        )
                      ) : (
                        <div>{selectedSkill?.name}</div>
                      )}
                    </>
                  )}
                </td>
                <td className="border p-2">
                  <div className="flex flex-col justify-start">
                    <div className="w-auto">{item.question}</div>
                    {item.image && (
                      <a
                        href={
                          `${process.env.REACT_APP_BASE_URL}` +
                          item.image
                        }
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={
                            `${process.env.REACT_APP_BASE_URL}` +
                            item.image
                          }
                          className="max-w-[500px]"
                          alt="question"
                        />
                      </a>
                    )}
                  </div>
                </td>

                <td className="border p-2">
                  {item.answer && item.answer.length > 0 && (
                    <>
                      {Object.entries(item.answer).map(([key2, item2]) => (
                        <div key={key2}>
                          <div className="flex justify-start h-auto">
                            <div className="w-8 shadow-2xl mx-2 mr-2">
                              {item2.image && (
                                <a
                                  href={
                                    `${process.env.REACT_APP_BASE_URL}` +
                                    item2.image
                                  }
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <img
                                    src={
                                      `${process.env.REACT_APP_BASE_URL}` +
                                      item2.image
                                    }
                                    width="50"
                                    height="50"
                                    alt="answer"
                                  />
                                </a>
                              )}
                            </div>
                            <div className="w-auto">
                              {item2.answer}
                              {item2.result ? (
                                <i className="fa fa-check text-green-500 ml-1"></i>
                              ) : (
                                ""
                              )}
                              <br />
                            </div>
                          </div>
                        </div>
                      ))}
                    </>
                  )}
                </td>
              </tr>
            ))}
          {filterRecords === undefined && (
            <tr>
              <td colSpan="4" className="text-center">
                <i className="fa fa-spin fa-spinner fa-lg"></i>
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <div className="hidden w-10/12 mx-auto mb-1 sm:flex-1 sm:flex sm:items-center sm:justify-between sm:border-t-2 sm:border-b-2">
        <p className="text-sm text-gray-700">
          {t("pags.show")}
          <span className="font-medium ml-1 mr-1">{Number(data.init) + 1}</span>
          {t("pags.to")}
          <span className="font-medium ml-1 mr-1">
            {Number(data.final) + 1}
          </span>
          {t("pags.of")}
          <span className="font-medium ml-1 mr-1">
            {list.questions_list.length}
          </span>
          {t("pags.results")}
        </p>
        <div className="h-1 w-12 -mt-6 text-sm">
          <Select
            native
            onChange={(event) => {
              setLimit({
                ...limit,
                init: event.target.value,
              });
            }}
          >
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="15">15</option>
          </Select>
        </div>
        <Pagination
          className="d-flex flex-row align-items-center"
          current={data.current}
          total={list.questions_list.length}
          pageSize={limit.init}
          onChange={handlePage}
          locale={"es_ES"}
        />
      </div>
    </div>
  );
}
